<template>
    <va-edit-layout>
        <DebtRecoveryEventItem-form
            :id="id"
            :title="title"
            :item="item"
        ></DebtRecoveryEventItem-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
